import { isUndefined } from 'angular';
var ContentDictionaryService = (function () {
    function ContentDictionaryService($http, $q, $cacheFactory) {
        this.$http = $http;
        this.$q = $q;
        this.queue = [];
        this.cache = $cacheFactory('contentDictionary');
    }
    ContentDictionaryService.prototype.get = function (key) {
        var _this = this;
        var queueItemIndex = this.getQueueItemIndex(key);
        if (queueItemIndex > -1) {
            return this.queue[queueItemIndex].deferred.promise;
        }
        var deferred = this.$q.defer();
        var cachedTranslation = this.cache.get(key);
        if (!isUndefined(cachedTranslation)) {
            deferred.resolve(cachedTranslation);
            return deferred.promise;
        }
        var relativePath = key[0] + "/" + key;
        var url = "compatibilityguide/ng-translation/feature/dictionary?key=" + relativePath;
        var promise = this.$http.get(url);
        this.queue.push({ key: key, deferred: deferred });
        promise.then(function (response) {
            var translation = response.data;
            var queueIndexAfterResponse = _this.getQueueItemIndex(key);
            _this.cache.put(key, translation);
            if (queueIndexAfterResponse > -1) {
                _this.queue.splice(queueIndexAfterResponse);
            }
            deferred.resolve(translation);
        }, function () {
            deferred.reject();
        });
        return deferred.promise;
    };
    ContentDictionaryService.prototype.getQueueItemIndex = function (key) {
        var queueItemIndex = -1;
        for (var i = 0; i < this.queue.length; i++) {
            var queueItem = this.queue[i];
            if (queueItem.key !== key) {
                continue;
            }
            queueItemIndex = i;
            break;
        }
        return queueItemIndex;
    };
    ContentDictionaryService.$inject = ['$http', '$q', '$cacheFactory'];
    return ContentDictionaryService;
}());
export { ContentDictionaryService };
